
export const CHOICE_FORMAT_SINGLE_LINE = 'single_line'
export const CHOICE_FORMAT_PARAGRAPH = 'paragraph'
export const CHOICE_FORMATS = [
  CHOICE_FORMAT_SINGLE_LINE,
  CHOICE_FORMAT_PARAGRAPH
]

export const DATE_FORMAT_MDY = 'MM/DD/YYYY'
export const DATE_FORMAT_DMY = 'DD/MM/YYYY'
export const DATE_FORMAT_YMD = 'YYYY/MM/DD'
export const DATE_FORMAT_DEFAULT = DATE_FORMAT_MDY
export const DATE_FORMATS = [
  DATE_FORMAT_MDY,
  DATE_FORMAT_DMY,
  DATE_FORMAT_YMD
]
